// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__2oekE","header":"MessagesList_header__1bsbo","chat":"MessagesList_chat__2fMVs"};